import { makeObservable, computed } from "mobx";
import { BaseSyncModel } from "@/store/sync/BaseSyncModel";
import { SyncModelKind } from "@/store/sync/types";
import { WithAppStore } from "@/store/types";
import { SourceModelData } from "@/store/sources/types";
import { SyncUpdateValue } from "@/store/sync/types";

export class SourceObservable extends BaseSyncModel<SourceModelData> {
  public modelKind = SyncModelKind.Source;

  constructor({
    id,
    data,
    store,
  }: { id: string; data: SyncUpdateValue<SourceModelData> } & WithAppStore) {
    super({ id, data, store });

    makeObservable(this, {
      modelKind: false,
      sourceKind: computed,
      primaryLabel: computed,
      secondaryLabel: computed,
    });
  }

  get sourceKind() {
    return this.modelData.source_kind;
  }

  get primaryLabel() {
    return this.modelData.primary_label;
  }

  get secondaryLabel() {
    return this.modelData.secondary_label;
  }
}
